import { InventoryListFormFields } from '@openx/types/inventoryList.ts';
import { array, object, string } from 'yup';

export const inventoryListValidationSchema = object().shape({
  [InventoryListFormFields.NAME]: string().required(),
  [InventoryListFormFields.DESCRIPTION]: string().max(255, 'Description exceeds the maximum of 255 characters allowed'),
  [InventoryListFormFields.ACCOUNT_UID]: string().required('Organization field is required'),
  [InventoryListFormFields.LIST_TYPE]: string().required(),
  [InventoryListFormFields.VALUES]: array()
    .of(string())
    .test('at-least-one-item', 'Please enter at least one item', value => (value ? value.length > 0 : false)),
});
